import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'use-paths-table-data' })((theme) => ({
    description: {
        whiteSpace: 'normal',
        display: '-webkit-box',
        WebkitLineClamp: '2',
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    cwe: {
        whiteSpace: 'normal',
        display: '-webkit-box',
        WebkitLineClamp: '2',
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    link: {
        textDecoration: 'none',
        transition: 'all 0.1s',
        '&:hover': {
            color: theme.palette.primary.light,
            textDecoration: 'underline'
        }
    }
}));
